import { Globals } from "../CoreApp/Globals";

export function confirmExit() {
  return Globals._app.ConfirmExit();
}
